<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox">
          <div class="ibox-title">
            <h5><i class="fa fa-flag-checkered"></i> Livraison</h5>
          </div>
          <div class="ibox-content">
            <div>
              <div class="feed-activity-list">
                <div class="feed-element">
                  <div class="media-body">
                    <span> Adresse de la livraison : <strong>{{ delivery.address }}</strong></span>
                  </div>
                </div>
                <div class="feed-element">
                  <div class="media-body">
                    <span> Prix de la livraison : <strong>{{ delivery.price }} Euros</strong></span>
                  </div>
                </div>
                <div class="feed-element">
                  <div class="media-body">
                    <span> Date de livraison :
                      <button class="btn btn-primary btn-circle btn-plus-crz"
                              @click="onClickNewDate">
                        <i class="fa fa-plus"></i>
                      </button>
                      <strong v-if="delivery.date && !datePickerValue">
                        {{ [this.delivery.date, 'DD-MM-YYYY HH:mm:ss'] | moment("LLLL") }} </strong>
                      <strong v-if="datePickerValue"> {{ this.datePickerValue | moment("LLLL") }} </strong>
                    </span>
                    <datetime input-id="datetime-picker-departure"
                              input-class="hidden"
                              v-model="datePickerValue"
                              type="datetime"
                              :minute-step="15"
                              class="datepicker-theme">
                    </datetime>
                  </div>
                </div>
                <div class="feed-element">
                  <div class="media-body">
                    <button v-if="showUpdatedBtn" class="btn btn-success text-center"
                            :disabled="!notDisableDeliverySubmit"
                            type="button"
                            @click="submitDate">
                      <i class="fa fa-check"></i> Enregistrer la date
                    </button>
                    <button v-if="showRemovedBtn" class="btn btn-danger text-center"
                            :disabled="notDisableDeliverySubmit"
                            type="button"
                            @click="removeDate">
                      <i class="fa fa-close"></i> Replanifier le rendez-vous
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  name: "DeliveryLight",
  props: {
    command: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    delivery: {
      address: '',
      price: '',
      date: '',
    },
    datePickerValue: ''
  }),
  computed: {
    formattedDateType1() {
      return moment(this.delivery.date, 'DD-MM-YYYY HH:mm:ss').format('LLLL')
    },
    formattedDateType2() {
      return moment(this.datePickerValue).format('LLLL')
    },
    formattedDateForMutation() {
      return moment(this.datePickerValue).format('DD-MM-YYYY HH:mm:ss')
    },
    notDisableDeliverySubmit() {
      return this.datePickerValue != ''
    },
    showRemovedBtn() {
      return this.delivery.date !== ''
    },
    showUpdatedBtn() {
      return this.datePickerValue !== ''
    },
    deliveryDateMutation() {
      return gql`
                  mutation {
                    deliveryDate(
                      orderId: "${this.command.id}",
                      date: "${this.formattedDateForMutation}"
                    ) {
                      result
                      message
                      }
                   }`
    },
    removeDeliveryDateMutation() {
      return gql`
                  mutation {
                    cancelDelivery(orderId: "${this.command.id}") {
                      result
                      message
                    }
                   }`
    },
  },
  methods: {
    onClickNewDate() {
      document.getElementById('datetime-picker-departure').click()
    },
    async deliveryInfosQuery() {
      const deliveryInfos = await this.$apollo.query({
        query: gql`
                      query {
                       deliveryInfos (orderId: "${this.command.id}") {
                         address
                         date
                         price
                       }
                      }`,
        fetchPolicy: 'no-cache'
      })

      this.delivery.address = deliveryInfos.data.deliveryInfos.address
      this.delivery.price = (deliveryInfos.data.deliveryInfos.price !== '') ? deliveryInfos.data.deliveryInfos.price : 0;
      this.delivery.date = deliveryInfos.data.deliveryInfos.date
    },
    submitDate() {
      this.$apollo.mutate({
        mutation: this.deliveryDateMutation
      }).then(() => {
        this.showBanner('success', `La date de livraison a bien été ajoutée !`)
        this.deliveryInfosQuery()
        this.datePickerValue = ''
      }, () => {
        this.showBanner('danger', `La date de livraison n'a pas pu être modifiée !`)
      })

    },
    removeDate() {
      this.$apollo.mutate({
        mutation: this.removeDeliveryDateMutation
      }).then(() => {
        this.showBanner('success', `La date de livraison a bien été supprimée !`)
        this.datePickerValue = this.delivery.date = '';
      }, () => {
        this.showBanner('danger', `La date de livraison n'a pas pu être supprimée !`)
      })
    }
  },
  created() {

  },
  mounted() {
    this.deliveryInfosQuery()
  },

}
</script>
